import React from 'react';
import {
  ChevronLeftRounded,
  ChevronRightRounded,
  FirstPageRounded,
  LastPageRounded,
} from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import { VARIANTS } from 'shared/constants';

/**
 * @param {Object} props
 * @param {number} props.availablePages
 * @param {boolean} [props.disabled=false]
 * @param {boolean} [props.hidden=false]
 * @param {number} props.page
 * @param {Function} props.pageBack
 * @param {Function} props.pageFirst
 * @param {Function} props.pageForward
 * @param {Function} props.pageLast
 */
export default function PageControls(props) {
  const {
    availablePages,
    disabled = false,
    hidden = false,
    page,
    pageBack,
    pageFirst,
    pageForward,
    pageLast,
  } = props;

  if (hidden) {
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        display: 'flex',
        borderColor: 'borderColor',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '.25rem',
        padding: '.375rem .75rem',
        alignItems: 'center',
        textAlign: 'center',
        minWidth: 'fit-content',
        justifyContent: 'space-between',
      }}
      size="fit-content"
    >
      <Stack direction="row" spacing={1}>
        <IconButton
          size="small"
          variant={VARIANTS.outlined}
          color="primary"
          onClick={pageFirst}
          disabled={disabled || page === 1}
        >
          <FirstPageRounded />
        </IconButton>
        <IconButton
          size="small"
          variant={VARIANTS.outlined}
          color="primary"
          onClick={pageBack}
          disabled={disabled || page === 1}
        >
          <ChevronLeftRounded />
        </IconButton>
      </Stack>
      <Typography noWrap sx={{ width: 'fit-content' }}>{`Page ${page} of ${availablePages || 1}`}</Typography>
      <Stack direction="row" spacing={1}>
        <IconButton
          size="small"
          variant={VARIANTS.outlined}
          color="primary"
          onClick={pageForward}
          disabled={disabled || page >= availablePages}
        >
          <ChevronRightRounded />
        </IconButton>
        <IconButton
          size="small"
          variant={VARIANTS.outlined}
          color="primary"
          onClick={pageLast}
          disabled={disabled || page >= availablePages}
        >
          <LastPageRounded />
        </IconButton>
      </Stack>
    </Stack>
  );
}
